import {svgIconWrapper} from '../svg-icon-wrapper';

import FilterRegular from './filter-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <FilterRegular {...validProps} />;
}

SvgComponent.iconName = 'filter-regular';

export const FilterRegularIcon = svgIconWrapper(SvgComponent);
